module.exports = __webpack_public_path__ + "static/media/chest_sfx.5fd06a3b.ogg";